export const PARTICIPANT_NAME_REPLACER_PLACEHOLDER = '%|%';

export function replaceNameWithLink(allNames: string[], rawString: string) {
  const allNamesRegex = allNames.join('|');
  const regex = new RegExp(`(?:|^)(${allNamesRegex})(?=|$)`, 'g');

  return rawString.replaceAll(regex, match => {
    return `${PARTICIPANT_NAME_REPLACER_PLACEHOLDER}${match}${PARTICIPANT_NAME_REPLACER_PLACEHOLDER}`;
  });
}
